import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  featureNotAvailableOnCurrentPlan: {
    defaultMessage: 'Upgrade your plan to gain access to this feature',
    description: "Message shown when a feature is not available on the user's plan",
    id: 'ALM68e',
  },
  trialWithNoLabels: {
    defaultMessage: 'You must process 1 label to unlock (or access) this feature.',
    id: '/O0I+3',
    description: 'Message shown for locked analytics features for sellers in a trial with no labels',
  },
  upgradeButton: {
    defaultMessage: 'Upgrade',
    description: 'upgrade',
    id: '1gZ7cz',
  },
  automationRulesLimitedAccessDescription: {
    defaultMessage:
      'One or more created rules contains actions that are not supported with your current subscription. Remove the unsupported actions or upgrade your plan to reactivate.',
    description: "Message shown when a feature is not available on the user's plan",
    id: 'krQXU3',
  },
  automationRulesLimitedAccessTitle: {
    defaultMessage: 'Rule not supported',
    description: "Title shown when a feature is not available on the user's plan",
    id: 'N4gjR8',
  },
  promotionalBannerMessage: {
    defaultMessage: 'This feature is not available on your existing subscription plan.',
    description: 'Message shown in the promotional banner for unavailable features',
    id: '5ltD3r',
  },
  promotionalBannerTitle: {
    description: 'title for customs store feature upsell',
    defaultMessage: 'Upgrade your plan to support {featureName} and gain access to other premium features.',
    id: 'KD7QRr',
  },
  defaultFeatureName: {
    defaultMessage: 'current feature',
    description: 'Default feature name used in promotional banner',
    id: 'gVenZG',
  },
  updatePlanTooltip: {
    defaultMessage: 'Upgrade your plan to gain access to this feature',
    description: 'Tooltip message for updating plan to access a feature',
    id: 'EIZ7Au',
  },
});
